import Vue from 'vue';
import App from './App.vue';
import router from './router';
import api from './api/api.js';
import store from '@/store';
import 'lib-flexible/flexible';
import {Button} from 'vant' ;
Vue.use(Button);

import axios from './utils/http.js';
Vue.prototype.$axios = axios

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"; // 默认主题
Vue.use(ElementUI);

var imgurl = 'https://img.lanniuzai.com/'
Vue.prototype.$api = api
Vue.prototype.$imgurl = imgurl;
Vue.prototype.$videourl ='https://video.lanniuzai.com/';

Vue.config.productionTip = false;

import 'animate.css'
import animated from 'animate.css/animate.compat.css'
Vue.use(animated)

import common from './_mixin/common.js'
Vue.mixin(common)


/* eslint-disable no-new */
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: window.location.href.indexOf('bluejeanimages')>0 ? 'en' : 'zh',
  messages: {
    'zh':require('./lang/zh'),
    'en':require('./lang/en')
  }
})

if(window.location.href.indexOf('bluejeanimages')>0){
	require ('./assets/css/common.scss');
	Vue.prototype.$lang = 1;
}else{
	require ('./assets/css/commonE.scss');
	Vue.prototype.$lang = 0;
}
// 重构 权限重地  permission control
// import './permission'

new Vue({
	el: '#app',
	router,
	i18n,
    store,
	render: h => h(App),
}).$mount('#app')
